import React from 'react';
import { Button, IconSettings } from '@salesforce/design-system-react';

class CircleButton extends React.Component {
  handleSelect = () => {
    this.props.onBtnClick(this.props.personaId);
  };

  handleDelete = () => {
    this.props.onDeleteBtnClick(this.props.personaId);
  };

  render() {
    return (
      <IconSettings iconPath="/icons">
        <div
          onClick={this.props.onBtnClick ? this.handleSelect : null}
          className={this.props.outerClass}
        >
          <div
            style={{
              height: '125px',
              width: '125px',
            }}
          >
            <Button
              className={
                (this.props.isHero ? 'hero-persona ' : '') +
                'new-persona-btn' +
                (this.props.inactive ? ' inactive' : '')
              }
              style={{
                backgroundColor: this.props.color,
                backgroundImage: 'url(' + this.props.imgPath + ')',
                backgroundSize: this.props.imgSize + '%',
              }}
              assistiveText={{ icon: 'New' }}
              inverse
            >
              {this.props.isEditable ? (
                <div>
                  <Button
                    assistiveText={{ icon: 'Delete' }}
                    className="delete-btn"
                    iconCategory="utility"
                    iconName="delete"
                    iconSize="medium"
                    inverse
                    variant="icon"
                    onClick={this.handleDelete}
                  />
                </div>
              ) : null}
            </Button>
          </div>
          <div style={{ marginTop: '0', textAlign: 'center' }}>
            <p className="grey-font slds-text-heading_small page-block-header-title">
              {this.props.textBelow}
            </p>
            <p
              style={{ display: this.props.textBelow2 ? 'block' : 'none' }}
              className="light-grey-font slds-text-heading_small page-block-header-title"
            >
              {this.props.textBelow2}
            </p>
          </div>
        </div>
      </IconSettings>
    );
  }
}

export default CircleButton;
